import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BudgetService } from '../../budget.service';

@Component({
  selector: 'app-budget-approval-summary',
  templateUrl: 'budget-approval-summary.template.html'
})
export class BudgetApprovalSummaryComponent implements OnInit {
  public nav: any;
  private errorMessages: any;
  private title: string;
  private description1: string;
  private description2: string;
  constructor(private serviceSecurity: SecurityService
    , private configurationService: ConfigurationService
    , private route: ActivatedRoute
    , private config: AppConfig
    , private spinner: NgxSpinnerService
    , private serviceBudget: BudgetService
    , private identityService: IdentityService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['url']) {
        if (this.configurationService.isReady) {
          let u = params['url'];
          this.approveBudget(u);
        } else {
          this.configurationService.settingsLoaded$.subscribe(x => {
            let u = params['url'];
            this.approveBudget(u);
          });
        }
      }
    });
  }
  private approveBudget(id: string): void {
    let dto = {} as IDtoCatalog;
    dto.name = id;
    this.spinner.show()
    this.serviceBudget.approveBudget(dto)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.title = 'Presupuesto aprobado';
            this.description1 = 'Para más información acerca del presupuesto aprobado, lo invitamos a que se autentique en nuestra plataforma con los datos de acceso que se le ha proporcionado.';
            this.description2 = 'Si no cuenta con la información requerida para iniciar sesión, le invitamos a ponerse en contacto con su ejecutivo o el área de ventas.'
            this.addModuleLog(x.data as IDtoBudget);
          } else {
            this.title = x.exception;
            this.description1 = 'Le invitamos a ponerse en contacto con su ejecutivo o el área de ventas para mayor información.';
          }
          this.spinner.hide();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private addModuleLog(res: IDtoBudget): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'Budgets';
    dto.module = 'budgetApproval';
    dto.action = 'approval';
    dto.registryAffectedId = res.id;
    dto.userId = res.approverUserId;
    dto.employeeId = null;
    dto.role = 'Cliente';
    this.identityService.addModuleLogComplete(dto).subscribe(
      (x) => { });
  }
}
